import React from 'react';
import PropTypes from 'prop-types';
import Badge, { KINDS } from '../Badge';
import Tooltip from '../Tooltip';

const Tag = ({ title, children }) => {
  if (!title || !children) return null;

  return (
    <Badge kind={KINDS.SECONDARY}>
      <Tooltip title={title} preventOverflow>
        <span className="max-w-[144px] truncate">{children}</span>
      </Tooltip>
    </Badge>
  );
};

Tag.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Tag;
